import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, isNil, range, propOr, equals, findIndex, pluck } from 'ramda';

import Modal from './Modal';

class FiltersModal extends Component {
  constructor(props) {
    super(props);

    this.durations = [
      { label: '0 - 30 min.', value: { min: Number.MIN_SAFE_INTEGER, max: 30 } },
      { label: '30 - 60 min.', value: { min: 31, max: 60 } },
      { label: '60 - 90 min.', value: { min: 61, max: 90 } },
      { label: '90+ min.', value: { min: 91, max: Number.MAX_SAFE_INTEGER } },
    ];

    this.state = {
      numberOfPlayers: props.numberOfPlayers,
      categories: props.categories,
      duration: props.duration,
      durationIndex: this.getDurationIndex(props.duration),
    };

    this.onCloseModal = this.onCloseModal.bind(this);
    this.onFilterButtonClick = this.onFilterButtonClick.bind(this);
    this.onResetFiltersButtonClick = this.onResetFiltersButtonClick.bind(this);
    this.onChangeNumberOfPlayers = this.onChangeNumberOfPlayers.bind(this);
    this.isChecked = this.isChecked.bind(this);
    this.hasFilters = this.hasFilters.bind(this);
    this.onChangeCategory = this.onChangeCategory.bind(this);
    this.onChangeDuration = this.onChangeDuration.bind(this);
    this.getDurationIndex = this.getDurationIndex.bind(this);
  }

  componentDidUpdate() {
    if (!equals(this.state.duration, this.props.duration)) {
      const durationIndex = this.getDurationIndex(this.props.duration);
      this.setState({
        duration: this.props.duration,
        durationIndex,
      });
    }
  }

  getDurationIndex(duration) {
    const index = findIndex(equals(duration), pluck('value', this.durations));
    return index >= 0 ? index : '';
  }

  onChangeNumberOfPlayers(event) {
    event.preventDefault();
    event.persist();

    const value = event.target.value;

    const numberOfPlayers = !isEmpty(value)
      ? parseInt(value, 10)
      : '';

    this.setState({ numberOfPlayers });
  }

  onChangeCategory(event) {
    const id = event.target.value;
    const index = this.state.categories.indexOf(id);
    const categories = index > -1
      ? [
        ...this.state.categories.slice(0, index),
        ...this.state.categories.slice(index + 1),
      ]
      : [
        ...this.state.categories,
        id,
      ];
    
    this.setState({ categories });
  }

  onChangeDuration(event) {
    event.preventDefault();
    event.persist();

    const durationIndex = event.target.value;
    const duration = propOr(null, 'value', this.durations[durationIndex]);

    this.setState({ durationIndex, duration });
  }

  onCloseModal() {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  onFilterButtonClick() {
    const filters = {
      numberOfPlayers: this.state.numberOfPlayers,
      categories: this.state.categories,
      duration: this.state.duration,
    };

    this.props.onFilter(filters);
  }

  onResetFiltersButtonClick() {
    const filters = {
      numberOfPlayers: '',
      categories: [],
      duration: null,
    };

    this.setState({
      ...filters,
      durationIndex: '',
    }, () => {
      this.props.onFilter(filters);
    });
  }

  hasFilters() {
    return [
        this.state.numberOfPlayers,
        this.state.categories,
        this.state.duration,
      ]
      .map(filter => !isNil(filter) && !isEmpty(filter))
      .reduce((hasFilter, isNotEmpty) => hasFilter || isNotEmpty, false);

  }

  isChecked(id) {
    return this.state.categories.indexOf(id) > -1;
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen} onClose={this.onCloseModal} title="Filtra">
        <div className="w-full">
          <div className="flex flex-wrap -mx-3 mb-2">
            <div className="w-full md:w-full px-3 mb-6 md:mb-2">
              <div className="flex justify-center flex-row mb-10 flex-wrap md:w-2/3 w-full mx-auto">
                <div className="md:inline-block relative w-full md:w-1/2 mb-4 md:mb-0 md:pr-3">
                  <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="players_num">Numero di giocatori</label>
                  <div className="block relative">
                    <select
                      id="players_num"
                      className="appearance-none border border-gray-400 rounded-full w-full py-2 pl-5 pr-10 text-gray-700 leading-tight focus:outline-none focus:shadow"
                      value={this.state.numberOfPlayers}
                      onChange={this.onChangeNumberOfPlayers}>
                      <option value="">Qualunque</option>
                      {
                        range(2, this.props.maxNumberOfPlayers + 1)
                          .map(numberOfPlayers => (
                            <option key={numberOfPlayers} value={numberOfPlayers}>{numberOfPlayers}</option>
                          ))
                      }
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-darker">
                      <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                    </div>
                  </div>
                </div>
                <div className="md:inline-block relative w-full md:w-1/2 md:pl-3">
                  <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="players_num">Durata</label>
                  <div className="block relative">
                    <select
                      id="duration"
                      className="appearance-none border border-gray-400 rounded-full w-full py-2 pl-5 pr-10 text-gray-700 leading-tight focus:outline-none focus:shadow"
                      value={this.state.durationIndex}
                      onChange={this.onChangeDuration}>
                      <option value="">Qualunque</option>
                      {
                        this.durations
                          .map((duration, index) => (
                            <option key={index} value={index}>{duration.label}</option>
                          ))
                      }
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-darker">
                      <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-col mb-10 md:w-2/3 w-full mx-auto">
                <h2 className="block text-gray-700 text-sm font-bold mb-2">Categorie</h2>
                <div className="relative flex w-full flex-wrap">
                  {
                    this.props.categoryOptions.map(category => (
                      <label key={category.id} className="w-full md:w-1/2 block text-gray-700 font-medium mb-4">
                        <input className="mr-2 leading-tight" name='categories[]' type="checkbox" value={category.id} checked={this.isChecked(category.id)} onChange={this.onChangeCategory} />
                        <span>
                          { category.name }
                        </span>
                      </label>
                    ))
                  }
                </div>
              </div>
              <div className="flex justify-center flex-row flex-wrap md:w-2/3 w-full mx-auto">
                {
                  this.hasFilters() && 
                    <button
                      onClick={this.onResetFiltersButtonClick}
                      className="appearance-none border border-gray-600 bg-white hover:opacity-50 text-gray-600 flex justify-center items-center rounded-full px-4 py-1 mt-3 md:mt-0 w-full md:w-48 md:mr-4">
                      Reimposta
                    </button>
                }
                <button
                  onClick={this.onFilterButtonClick}
                  className="appearance-none border border-gray-600 bg-gray-600 hover:bg-white text-white hover:text-gray-600 flex justify-center items-center rounded-full px-4 py-1 mt-3 md:mt-0 w-full md:w-48">
                  Filtra
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

FiltersModal.propTypes = {
  maxNumberOfPlayers: PropTypes.number,
  onFilter: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  orderBy: PropTypes.string,
  categoryOptions: PropTypes.array,
  categories: PropTypes.array,
  duration: PropTypes.shape({
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
  }),
};

FiltersModal.defaultProps = {
  maxNumberOfPlayers: 10,
  isOpen: false,
  orderBy: 'title',
  numberOfPlayers: '',
  categories: [],
  durations: [],
};

export default FiltersModal;